import React from 'react';
import ComingSoon from 'components/ComingSoon';

export const Notarizator = () => (
  <ComingSoon text="Notarizator is a blockchain tool for recording and verifying documents, transactions, or data entries. It ensures these records are protected from unauthorized access and can be independently verified. Notarizator protects you and your business from fraud and manipulations." />
);
